import React from 'react'

// components
import InputField from '../../InputField/InputField.component'

// styles
import './EquipmentRequestInput.css'

// mui
import { Container, Grid, Typography, Paper, IconButton } from '@mui/material'
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle'

export default function EquipmentRequestInput({ equipmentName, sku, prefix, handleChange, handleRemove, requestQty, errors }) {
    return (<Grid container spacing={4}>
        <Grid item xs={1}>
            <IconButton onClick={handleRemove}>
                <RemoveCircleIcon color='error' />
            </IconButton>
        </Grid>
        <Grid item xs={11}>
            <Container disableGutters sx={{ marginBottom: 4}}>
                <Paper variant='outlined' sx={{ padding:2}}>
                    <Grid container spacing={2} columns={14} alignItems='center'>
                        <Grid item xs={4} sx={{ marginBottom: 2}}><Typography variant='h5'>{equipmentName}</Typography></Grid>
                        <Grid item xs={4} sx={{ marginBottom: 1}}><Typography><b>SKU#</b> {sku}</Typography></Grid>
                        <Grid item xs={6}>
                            <InputField 
                            
                                id={`${prefix}.requestQty`}
                                type="text"
                                placeholder='Requested Quantity'
                                onChange={handleChange}
                                value={requestQty}
                                isValid={errors['requestQty']}
                            />
                        </Grid>
                    </Grid>
                </Paper>
            </Container>
        </Grid>
    </Grid>)
}